module.exports = __webpack_public_path__ + "img/appstoreios.29cb5936.jpg";